import { getCustomer, getCycleDate } from "../Authorization";

const WrapOption = () => {
  return {
    cycle_date: getCycleDate(),
    customer: getCustomer(),
    wrap_url: process.env.REACT_APP_WRAP_URL,
    expo_map_url: process.env.REACT_APP_EXPO_MAP_URL,
    expo_tile_sat_url: process.env.REACT_APP_EXPO_TILE_SAT_URL,
    expo_tile_gpv_url: process.env.REACT_APP_EXPO_TILE_GPV_URL
  }
}
export default WrapOption;